const urls = {
  GAMMA: "http://192.168.29.150/",
  PROD: "https://www.valuemrp.com/",
  LOCAL: "http://localhost:8082/"
};

export const GTMTags = {
  BETA: "G-XS3DN1T9HS",
  PROD: "G-TDQPF5HHCJ"
};

const baseURL = urls[process.env.REACT_APP_URL_ENV] ?? urls.LOCAL;

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

const loginWithTokenURL = `${baseURL}api/auth/tokenLogin`;
const loginURL = `${baseURL}api/auth/login`;
const phoneNumberLogin = `${baseURL}api/auth/login/number`;
const refreshToken = `${baseURL}api/auth/refresh`;
const signupURL = `${baseURL}api/auth/user-registration`;
const logoutURL = `${baseURL}api/auth/logout`;
const otpGenerate = `${baseURL}api/v1/otp/generate`;
const otpValidate = `${baseURL}api/v1/otp/validate`;
const resetPassword = `${baseURL}api/v1/utils/reset-password`;

const analytics = `${baseURL}api/v1/analytics/get-analytics`;
const analyticsSlabTypeVolume = `${baseURL}api/v1/analytics/goods-produced`;
const analyticsV2 = `${baseURL}api/v1/analytics/v2`;
const uploadBroadcasts = `${baseURL}api/v1/broadcast/parse-broadcasts`;
const broadcastDetails = `${baseURL}api/v1/broadcast/broadcasts`;
const broadcastTemplates = `${baseURL}api/v1/broadcast/broadcast-templates`;
const broadcastLimit = `${baseURL}api/v1/broadcast/broadcast-limit`;
const couponsSummary = `${baseURL}api/v1/coupon/summary`;
const coupons = `${baseURL}api/v1/coupon/all`;
const couponRedeem = `${baseURL}api/v1/coupon/redeem`;
const supplierCreditProviders = `${baseURL}api/v1/credit-provider`;
const creditDetails = `${baseURL}api/v1/credit-provider/details`;
const createCreditPayment = `${baseURL}api/v1/credit-provider/payment`;
const allCreditProviders = `${baseURL}api/v1/credit-provider/all`;
const creditFlowRedirect = `${baseURL}api/v1/credit-provider/redirect`;
const creditProviders = `${baseURL}api/v1/credit-provider/details/grid`;
const searchSupplierProductDetails = `${baseURL}api/v1/inventory/customer/search`;
const globalSupplierIds = `${baseURL}api/v1/inventory/global-suppliers`;
const getSuggestedProducts = `${baseURL}api/v1/inventory/customer/suggested`;
const inventoryDetails = `${baseURL}api/v1/inventory/supplier/all`;
const supplierProductsList = `${baseURL}api/v1/inventory/supplier/list`;
const updateInventoryStatus = `${baseURL}api/v1/inventory/update-visibility`;
const uploadInventory = `${baseURL}api/v1/inventory/inventory-ingestion`;
const productInventory = `${baseURL}api/v1/inventory/product`;
const updateThreshold = `${baseURL}api/v1/inventory/update/threshold`;
const invoiceDetailsWithUpdateId = `${baseURL}api/v1/invoice/details-for-update`;
const invoiceDetails = `${baseURL}api/v1/invoice`;
const invoiceStatus = `${baseURL}api/v1/invoice/statuses`;
const getAllInvoices = `${baseURL}api/v1/invoice/find-all`;
const outstandingInvoices = `${baseURL}api/v1/invoice/outstanding`;
const supplierLedger = `${baseURL}api/v1/ledger/all`;
const getRepresentativeLedgers = `${baseURL}api/v1/ledger/representative`;
const updateLedger = `${baseURL}api/v1/ledger/update`;
const uploadLedger = `${baseURL}api/v1/ledger/ledger-ingestion`;
const removeLocation = `${baseURL}api/v1/ledger/remove-location`;
const addToCart = `${baseURL}api/v1/cart-new/create`;
const cartDetailsURL = `${baseURL}api/v1/cart-new/get-cart-details`;
const updateCart = `${baseURL}api/v1/cart-new/update`;
const productMappingProducts = `${baseURL}api/v1/product-inventory/get-product-inventories`;
const productMappingInventory = `${baseURL}api/v1/product-inventory/get-inventories`;
const saveProductMapping = `${baseURL}api/v1/product-inventory/update-product-inventories`;
const createProduct = `${baseURL}api/v1/product-inventory/create-product`;

const updateCartHold = `${baseURL}api/v1/cart-new/hold`;
const clearCart = `${baseURL}api/v1/cart-new/clear`;
const offerCreate = `${baseURL}api/v1/offer/create`;
const offerUpdate = `${baseURL}api/v1/offer/update`;
const getOffers = `${baseURL}api/v1/offer/all`;
const bannerImages = `${baseURL}api/v1/offer/banner-images?env=web`;
const deleteOffer = `${baseURL}api/v1/offer/delete`;
const cartPlaceOrder = `${baseURL}api/v1/order/create`;
const orderStatuses = `${baseURL}api/v1/order/allStatuses`;
const findOrders = `${baseURL}api/v1/order/find-orders`;
const getOrdersDateView = `${baseURL}api/v1/order/date-view`;
const getOrderDetails = `${baseURL}api/v1/order`;
const reorder = `${baseURL}api/v1/order/reorder`;
const updateOrderByAction = `${baseURL}api/v1/order/action`;
const receivedOrdersCustomers = `${baseURL}api/v1/order/pending/customers`;
const updateCustomerOrdersToInvoicing = `${baseURL}api/v1/order/manual-invoicing`;
const findOrdersByProductSearch = `${baseURL}api/v1/order/find-orders/productSearch`;
const findOrdersBySupplierProductSearch = `${baseURL}api/v1/order/find-orders/supplier-productSearch`;
const createLedgerOrder = `${baseURL}api/v1/order/create-ledger-order`;
const saveParserConfig = `${baseURL}api/v1/parser-config/save`;
const fetchParserConfigTemplate = `${baseURL}api/v1/parser-config/fetch-template`;
const fetchFileHeader = `${baseURL}api/v1/parser-config/fetch-header`;
const raisePaymentRequest = `${baseURL}api/v1/payment/raise-request`;
const payPayment = `${baseURL}api/v1/payment/pay`;
const updatePayment = `${baseURL}api/v1/payment/update`;
const paymentRequests = `${baseURL}api/v1/payment/requests`;
const paymentOutstanding = `${baseURL}api/v1/payment/outstanding`;
const paymentCollectionStatuses = `${baseURL}api/v1/payment/all-collection-statuses`;
const paymentsDownload = `${baseURL}api/v1/payment/report`;
const paymentTypes = `${baseURL}api/v1/payment/types`;
const deletePreCartItem = `${baseURL}api/v1/preCart/delete`;
const updatePreCartItem = `${baseURL}api/v1/preCart/update`;
const addToPreCart = `${baseURL}api/v1/preCart/create`;
const getPreCarts = `${baseURL}api/v1/preCart/all`;
const addToCartFromPreCarts = `${baseURL}api/v1/preCart/add-to-cart`;
const getAllDrugInfo = `${baseURL}api/v1/product/all`;
const getDrugSubs = `${baseURL}api/v1/product/find`;
const suggestProduct = `${baseURL}api/v1/product/send-product`;
const uploadPurchaseOrderV2 = `${baseURL}api/v2/purchaseOrder/upload`;
const purchaseOrderSupplierMapping = `${baseURL}api/v2/purchaseOrder/supplier-mapping`;
const purchaseOrderInventoryMapping = `${baseURL}api/v2/purchaseOrder/inventory-mapping`;
const updatePurchaseOrderDetail = `${baseURL}api/v2/purchaseOrder/update`;
const allPurchaseOrdersV2 = `${baseURL}api/v2/purchaseOrder/all`;
const deletePoDetails = `${baseURL}api/v2/purchaseOrder/details`;
const suggestProductForPO = `${baseURL}api/v2/purchaseOrder/suggest-product`;
const quotations = `${baseURL}api/v1/quotation/all`;
const quotationDetails = `${baseURL}api/v1/quotation/details/`;
const createQuotation = `${baseURL}api/v1/quotation/create`;
const quotationOrder = `${baseURL}api/v1/quotation/order`;
const deactivateQuotation = `${baseURL}api/v1/quotation/deactivate/`;
const getSettings = `${baseURL}api/v1/settings/fetch`;
const getSettingsByUserId = `${baseURL}api/v1/settings/by-userId`;
const flipPaymentNotificationSetting = `${baseURL}api/v1/settings/update/paymentNotification`;
const getAllSubscriptions = `${baseURL}api/v1/subscriptions/all`;
const subscriptionPayment = `${baseURL}api/v1/subscriptions/pay`;
const createSupplierCustomerURL = `${baseURL}api/v1/customers/associate-divisions`;
const allAssociatedUsers = `${baseURL}api/v1/customers/all`;
const supplierDetails = `${baseURL}api/v1/customers/approved`;
const allAssociatedUsersList = `${baseURL}api/v1/customers/all/list`;
const customersUpdate = `${baseURL}api/v1/customers/update`;
const deleteAssociation = `${baseURL}api/v1/customers/`;
const customersBlock = `${baseURL}api/v1/customers/status`;
const suppliersPriority = `${baseURL}api/v1/customers/priority`;
const suggestSupplier = `${baseURL}api/v1/customers/suggest-supplier`;
const updateSalesmanCodes = `${baseURL}api/v1/representative/update-salesman-codes/`;
const representatives = `${baseURL}api/v1/representative/all`;
const representativesList = `${baseURL}api/v1/representative/all-list`;
const supplierRepresentativeList = `${baseURL}api/v1/representative/all-list/0`;
const updateRepresentative = `${baseURL}api/v1/representative/update`;
const representativeUpdate = `${baseURL}api/v1/representative/update-details`;
const representativeCreate = `${baseURL}api/v1/representative/create`;
const supervisorsList = `${baseURL}api/v1/representative/supervisors`;
const getRepresentativeAttendance = `${baseURL}api/v1/representative/attendance`;
const supportCreateRequest = `${baseURL}api/v1/support/createRequest`;
const userStatuses = `${baseURL}api/v1/user/all-user-statuses`;
const requestStatuses = `${baseURL}api/v1/user/all-request-statuses`;
const updateUserProfile = `${baseURL}api/v1/user/update-profile`;
const storeUserDeviceDetails = `${baseURL}api/v1/user/session-device`;
const userProfile = `${baseURL}api/v1/user/profile`;
const searchUsersURL = `${baseURL}api/v1/user/search`;
const newUsersURL = `${baseURL}api/v1/user/new`;
const switchRoleUrl = `${baseURL}api/v1/user/switch`;
const tokenByUserId = `${baseURL}api/v1/user/token`;
const userSettings = `${baseURL}api/v1/user/settings/fetch`;
const updateSettings = `${baseURL}api/v1/user/settings/save`;
const userCreditConsent = `${baseURL}api/v1/user-consent/fetch`;
const userCreditConsentSave = `${baseURL}api/v1/user-consent/save`;
const userGroups = `${baseURL}api/v1/userGroup/all`;
const userGroupsList = `${baseURL}api/v1/userGroup/list`;
const userGroupURL = `${baseURL}api/v1/userGroup/`;
const persistUserGroup = `${baseURL}api/v1/userGroup/persist`;
const updateLocation = `${baseURL}api/v1/location/update`;
const getRepresentativeLocation = `${baseURL}api/v1/location/get`;
const userNumber = `${baseURL}api/v1/user-number`;
const removeUserNumber = `${baseURL}api/v1/user-number/session`;
const removeAllUserNumbers = `${baseURL}api/v1/user-number/all-sessions`;
const allStates = `${baseURL}api/v1/utils/states`;
const allDistricts = `${baseURL}api/v1/utils/districts/`;
const fullPageBanner = `${baseURL}api/v1/utils/full-banner`;
const newNotifications = `${baseURL}api/v1/notifications/new`;
const allNotifications = `${baseURL}api/v1/notifications/all`;
const logisticOrders = `${baseURL}api/v1/logistics/grid`;
const logisticsDropdown = `${baseURL}api/v1/logistics/destinations`;
const logisticsQuotes = `${baseURL}api/v1/logistics/quotes`;
// const createLogisticsOrder = `${baseURL}api/v1/logistics/order`;
const createLogisticsOrder = `${baseURL}api/v1/logistics/order-pay`;
const cancelLogisticsOrder = `${baseURL}api/v1/logistics/cancel`;
const erpUsers = `${baseURL}api/v1/erp/customers`;
const erpAnalytics = `${baseURL}api/v1/erp/analytics`;
const getSlabTypes = `${baseURL}api/v1/slab/get-select-types`;
const getSubBlocks = `${baseURL}api/v1/sub-block/get-sub-blocks-slab-entry`;
const getSlabs = `${baseURL}api/v1/slab/get-slabs`;
const getCategories = `${baseURL}api/v1/material-category/get-material-categories`;
const updateSlabs = `${baseURL}api/v1/slab/update-slabs`;
const getMainBlocks = `${baseURL}api/v1/mainblock/get-main-blocks`;
const getAllMainBlocks = `${baseURL}api/v1/mainblock/get-all-main-blocks`;
const getSubBlockList = `${baseURL}api/v1/sub-block/get-sub-block-details`;
const getSlabsHistory = `${baseURL}api/v1/slab/get-slab-histories`;
const getSelectTypes = `${baseURL}api/v1/mainblock/get-select-types`;
const getSaleMaterialTypes = `${baseURL}api/v1/analytics/sale-material-types`;
const getSalePolishTypes = `${baseURL}api/v1/analytics/sale-polish-types`;
const getStockMaterialTypes = `${baseURL}api/v1/analytics/stock-material-types`;
const getStockPolishTypes = `${baseURL}api/v1/analytics/stock-polish-types`;
const getMaterialCategoriesTypes = `${baseURL}api/v1/material-category/get-material-categories-types`;
const getSaleRecords = `${baseURL}api/v1/sale/get-sale-records`;
const getSaleRecord = `${baseURL}api/v1/sale/get-sale-record`;
const saveSaleRecord = `${baseURL}api/v1/sale/save-sale-report`;
const yardDetails = `${baseURL}api/v1/mainblock/get-main-blocks`;
const addMainBlock = `${baseURL}api/v1/mainblock/create-main-block`;
const updateMainBlock = `${baseURL}api/v1/mainblock/update-main-block`;
const getCutters = `${baseURL}api/v1/utils/cutters`;
const createSubBlock = `${baseURL}api/v1/sub-block/create-sub-block`;
const getPendingSubBlocks = `${baseURL}api/v1/sub-block/get-pending-sub-blocks`;
const generateSlabs = `${baseURL}api/v1/slab/create-slabs`;
const genereateRecutSubBlocks = `${baseURL}api/v1/sub-block/recut-sub-blocks`;
const createUser = `${baseURL}api/v1/user/create-sub-user`;
const addQuarry = `${baseURL}api/v1/user/add-quarry`;
const addTransport = `${baseURL}api/v1/user/add-transport`;
const addCutter = `${baseURL}api/v1/user/add-cutter`;
const addMaterial = `${baseURL}api/v1/user/add-material-type`;
const getSubUsers = `${baseURL}api/v1/user/sub-users`;
// RMPM API Calls
const inventoryLocations = `${baseURL}api/v1/inventory/locations`;
const findPurchaseOrders = `${baseURL}api/v1/purchase-order/find-purchase-orders`;
const getPurchaseOrderDetails = `${baseURL}api/v1/purchase-order`;
const updateOrderStatus = `${baseURL}api/v1/order/updatestatus`;
const getOrderStatusSettings = `${baseURL}api/v1/order/statusSettings`;
const userAllRole = `${baseURL}api/v1/user/get-creation-roles`;
const getProductInventories = `${baseURL}api/v1/product-info/get-product-inventories`;
const getLocations = `${baseURL}api/v1/user-depot/get-locations`;
const getUserDetails = `${baseURL}api/v1/user/get-user-details`;
const addLocation = `${baseURL}api/v1/user-depot/add-location`;
const getAllProducts = `${baseURL}api/v1/product-info/all`;
const assignProductsToUser = `${baseURL}api/v1/user-product-info/add-products`;
const getAllGoods = `${baseURL}api/v1/goods/allhistory`;
const pushGoods = `${baseURL}api/v1/goods/push-to-sfg`;
const getPendingSFG = `${baseURL}api/v1/goods/pending-sfg`;
const createRMPMUser = `${baseURL}api/v1/user/create`;
const blockUnblockUser = `${baseURL}api/v1/user/block-user`;
const getGraniteSettings = `${baseURL}api/v1/settings/fetch-granite-settings`;
const updateGraniteSettings = `${baseURL}api/v1/settings/update-granite-settings`;
const getRawBlocksFactoryReport = `${baseURL}api/v1/reports/raw-blocks-factory`;
const getRawBlocksQuaryReport = `${baseURL}api/v1/reports/raw-blocks-quarry`;
const getResizedBlocksFactoryReport = `${baseURL}api/v1/reports/resized-blocks`;
const getProductionReport = `${baseURL}api/v1/reports/actual-production`;
const updateQuarryStatus = `${baseURL}api/v1/user/update-quarry-status`;
const updateTransportStatus = `${baseURL}api/v1/user/update-transport-status`;
const updateWireSawStatus = `${baseURL}api/v1/user/update-wiresaw-status`;
const updateMulticutterStatus = `${baseURL}api/v1/user/update-multicutter-status`;
const updateMaterialStatus = `${baseURL}api/v1/user/update-material-status`;
const getPolishTypes = `${baseURL}api/v1/slab/get-select-types`;
const addPolishType = `${baseURL}api/v1/user/add-polishtype`;
const updatePolishStatus = `${baseURL}api/v1/user/update-polish-status`;
const getSaleSelects = `${baseURL}api/v1/sale/get-sale-selects`;
const addSlabs = `${baseURL}api/v1/slab/add-new-slabs`;
const deleteLastSlabs = `${baseURL}api/v1/slab/delete-last-slabs`;
const deleteSaleRecord = `${baseURL}api/v1/sale/delete-sale-record`;
const scmDetails = `${baseURL}api/v1/supply-chain-management/get-all-scm`;
const scmUpdate = `${baseURL}api/v1/supply-chain-management/update-scm`;
const scmAdd = `${baseURL}api/v1/supply-chain-management/raise-scm`;
const getCostHeaders = `${baseURL}api/v1/costhead/get-cost-heads`;
const updateCostHeaderStatus = `${baseURL}api/v1/user/update-costHead-status`;
const addCostHeader = `${baseURL}api/v1/user/add-productionCostCategory`;
const getInventoryHeaders = `${baseURL}api/v1/granite/store-inventory/get-store-headers`;
const updateInventoryHeaderStatus = `${baseURL}api/v1/user/update-storeInventory-status`;
const addInventoryHeader = `${baseURL}api/v1/user/add-storeInventory`;
const getStoreInventoryRecords = `${baseURL}api/v1/granite/store-inventory/get-store-inventory-records`;
const getProductionCostRecords = `${baseURL}api/v1/costhead/get-cost-head-details`;
const saveStoreInventoryRecords = `${baseURL}api/v1/granite/store-inventory/save-store-inventory`;
const saveProductionCostRecords = `${baseURL}api/v1/costhead/save-costhead-details`;
const allProducts = `${baseURL}api/v1/product/all`;
const allProductsInventory = `${baseURL}api/v1/product/inventory`;
const createOrder = `${baseURL}api/v1/order/create`;
const getMainBlockSlabCounts = `${baseURL}api/v1/sale/get-block-wise-slab-selects`;
const getMainBlockSlabCountsByDimensions = `${baseURL}api/v1/sale/get-main-block-slab-counts-by-dimensions`;
const rmpmSaleList = `${baseURL}api/v1/rmpm/sale/get-sale-report`;
const getProductsByLocation = `${baseURL}api/v1/rmpm/sale/get-fg-product-info`;
const saveRmpmSale = `${baseURL}api/v1/rmpm/sale/save-sale-report`;
const getScmRecord = `${baseURL}api/v1/comparative-statement/get-cs`;
const addScmRecord = `${baseURL}api/v1/comparative-statement/add-cs`;
const savePreviewQuotation = `${baseURL}api/v1/sale-quotation/create-quotation`;
const acceptComparativeStatement = `${baseURL}api/v1/comparative-statement/accept-cs`;
const getAllSaleQuotations = `${baseURL}api/v1/sale-quotation/get-all-sale-quotations`;
const getAllPurchaseOrders = `${baseURL}api/v1/scm-po/get-all-scm-po`;
const addPurchaseOrder = `${baseURL}api/v1/scm-po/save-scm-po`;
const getPurchaseStatuses = `${baseURL}api/v1/scm-po/get-scm-po-status`;
const updatePoStatuses = `${baseURL}api/v1/scm-po/update-po-status`;
const getAllGrn = `${baseURL}api/v1/grn/get-all-grn`;
const addGrn = `${baseURL}api/v1/grn/add-grn`;
const getAllMaterialTypes = `${baseURL}api/v1/grn/get-all-materialTypes`;
const getProductQuantities = `${baseURL}api/v1/product-inventory/get-product-quantities`;
const createPreBatchOrder = `${baseURL}api/v1/order/create-prebatched`;
const inventoryLocationWarehouses = `${baseURL}api/v1/inventory/all-location-warehouses`;
const updateScmStatus = `${baseURL}api/v1/supply-chain-management/update-scm-status`;
const approveCs = `${baseURL}api/v1/comparative-statement/approve-cs`;
const addDin = `${baseURL}api/v1/din/add`;
const getAllDin = `${baseURL}api/v1/din`;
const getDispatchList = `${baseURL}api/v1/dispatch-quantity`;
const createProductionRequirement = `${baseURL}api/v1/product-inventory/create-production-requirement`;
const getProductById = `${baseURL}api/v1/product-inventory/get-product`;
const getAllPreBatches = `${baseURL}api/v1/pre-batch/get-all-batches`;
const getPreBatchById = `${baseURL}api/v1/pre-batch/get-batch`;
const updatePreBatch = `${baseURL}api/v1/pre-batch/update-batch`;
const deletePreBatch = `${baseURL}api/v1/pre-batch/delete-batch`;
const getGeneralConditions = `${baseURL}api/v1/general-conditions/get`;
const getUserAddress = `${baseURL}api/v1/user-address/get`;
const getAllGoodsForReprocess = `${baseURL}api/v1/product/goodsallhistory`;
const reprocessCreate = `${baseURL}api/v1/product/reprocessRiseOrder`;
const finishReprocess = `${baseURL}api/v1/goods/finish-reprocess`;
const updateQuotationStatus = `${baseURL}api/v1/sale-quotation-detail/update-quotation-status`;
const updateQuotationDetails = `${baseURL}api/v1/sale-quotation-detail/update-quotation-details`;
const getProducts = `${baseURL}api/v1/din/products`;
const getSaleForDin = `${baseURL}api/v1/rmpm/sale/get-sale-din`;
const getSaleQuotationById = `${baseURL}api/v1/sale-quotation/get-sale-quotation`;
const getScmPo = `${baseURL}api/v1/scm-po/get-scm-po`;

const getCompanyDetails = `${baseURL}api/v1/user/get-company-data`;
const getPendingGrn = `${baseURL}api/v1/grn-qc/get-pending-grns`;
const approveGRN = `${baseURL}api/v1/grn-qc/approve-grn`;
const rejectGRN = `${baseURL}api/v1/grn-qc/reject-grn`;

const getPoNumbers = `${baseURL}api/v1/sale-quotation/get-all-po-numbers`;
const getDetailsByPoNumber = `${baseURL}api/v1/sale-quotation/get-details-by-po-number`;
const getQuotationAnalytics = `${baseURL}api/v1/sale-quotation/analytics`;
const getSalesAnalytics = `${baseURL}api/v1/rmpm/sale/dashboard`;
const getAllStatesByCountryId = `${baseURL}api/v1/admin/get-all-states/{id}`;
const addDispatchQuantity = `${baseURL}api/v1/dispatch-quantity/add`;
const getDispatches = `${baseURL}api/v1/dispatch-quantity/get-all`;
const getDinById = `${baseURL}api/v1/din`;

// Borrow Requests API
const getOutgoingBorrowRequests = `${baseURL}api/v1/borrow-request/outgoing`;
const getIncomingBorrowRequests = `${baseURL}api/v1/borrow-request/incoming`;
const approveBorrowRequest = `${baseURL}api/v1/borrow-request/approve`;
const rejectBorrowRequest = `${baseURL}api/v1/borrow-request/reject`;
const lenderReservations = `${baseURL}api/v1/reservation/lender-reservations`;
const storePendingBorrowRequests = `${baseURL}api/v1/borrow-request/store-pending`;

const storeReleaseBorrowRequest = `${baseURL}api/v1/borrow-request/store-release`;
const lenderOrderReservations = `${baseURL}api/v1/reservation/lender-order-reservations`;
const getHoldersByInventory = `${baseURL}api/v1/reservation/holders`;
const createBorrowRequest = `${baseURL}api/v1/borrow-request/create`;

const scmProductGetDepartments = `${baseURL}api/v1/scm-product/departments`;
const scmProductGetAll = `${baseURL}api/v1/scm-product/get-all`;
const scmProductCreateProduct = `${baseURL}api/v1/scm-product/create`;
const scmProductGetByDepartment = `${baseURL}api/v1/scm-product/get-by-department`;
const scmProductGetById = `${baseURL}api/v1/scm-product/get`;
const scmProductUpdate = `${baseURL}api/v1/scm-product/update`;
const scmProductDelete = `${baseURL}api/v1/scm-product/delete`;
const getScmpoNumbers = `${baseURL}api/v1/grn/get-po-numbers`;
const addLedger = `${baseURL}api/v1/ledger/add`;
const getPartyNames = `${baseURL}api/v1/ledger/party-names`;
const getAllLedgers = `${baseURL}api/v1/ledger/get-ledgers`;
const getLedgerById = `${baseURL}api/v1/ledger/get-ledger`;
const updateLedgerById = `${baseURL}api/v1/ledger/update-ledger`;
const getCountries = `${baseURL}api/v1/ledger/get-countries`;
const getStates = `${baseURL}api/v1/ledger/get-states`;
const getDistricts = `${baseURL}api/v1/ledger/get-districts`;
const getPartyCodes = `${baseURL}api/v1/ledger/get-party-codes`;
const getDinPoNumbers = `${baseURL}api/v1/din/get-all-pos`;
const getActiveCreditorLedgers = `${baseURL}api/v1/ledger/get-active-creditor-ledgers`;
const getActiveDebtorLedgers = `${baseURL}api/v1/ledger/get-active-debtor-ledgers`;
const getApprovedComparativeStatements = `${baseURL}api/v1/comparative-statement/get-approved-comparative-statements`;
const getProcessAndPackingManagers = `${baseURL}api/v1/user/get-all-process-and-packing-managers`;
const updatePharmaSettings = `${baseURL}api/v1/settings/update-pharma-settings`;
const getPharmaSettings = `${baseURL}api/v1/settings/fetch-pharma-settings`;
const getCompanies = `${baseURL}api/v1/masterReports/get-companies`;
const getCompanyLocations = `${baseURL}api/v1/masterReports/get-locations`;
const getProductionData = `${baseURL}api/v1/masterReports/get-production-data`;
const getSaleData = `${baseURL}api/v1/masterReports/get-sale-data`;
const getStoreData = `${baseURL}api/v1/masterReports/get-stock-data`;
const getScmData = `${baseURL}api/v1/masterReports/get-scm-data`;

const filters = `${baseURL}api/v1/dpower/analytics/filters`;
const dashboard = `${baseURL}api/v1/dpower/analytics/dashboard`;
const sundryBalance = `${baseURL}api/v1/dpower/analytics/get-sundry-balance`;
const sundryBills = `${baseURL}api/v1/dpower/analytics/get-sundry-bills`;
const getMonthlyBalance = `${baseURL}api/v1/dpower/analytics/monthly-balance`;
const bankBalance = `${baseURL}api/v1/dpower/analytics/get-total-balance`;
const treasureFilters = `${baseURL}api/v1/dpower/analytics/get-banks`;
const bankWiseBalance = `${baseURL}api/v1/dpower/analytics/get-bank-balances`;
const bankWiseTransactions = `${baseURL}api/v1/dpower/analytics/get-transactions`;
const pendingBills = `${baseURL}api/v1/dpower/analytics/get-pending-bills`;
const getSalesDashboard = `${baseURL}api/v1/sale/analytics/dashboard`;
const productWiseOrders = `${baseURL}api/v1/sale/analytics/product-sale`;
const productSaleInfo = `${baseURL}api/v1/sale/analytics/product-sale-info`;
const getStockDashboard = `${baseURL}api/v1/rmpm/analytics/stocks/dashboard`;
const lowStockItems = `${baseURL}api/v1/rmpm/analytics/stocks/low-stock-products`;
const APIConstants = {
  baseURL,
  defaultHeaders,
  loginWithTokenURL,
  getSaleRecords,
  getSaleRecord,
  saveSaleRecord,
  getQuotationAnalytics,
  getMaterialCategoriesTypes,
  loginURL,
  phoneNumberLogin,
  refreshToken,
  signupURL,
  logoutURL,
  otpGenerate,
  otpValidate,
  resetPassword,
  analytics,
  analyticsSlabTypeVolume,
  analyticsV2,
  uploadBroadcasts,
  broadcastDetails,
  broadcastTemplates,
  pushGoods,
  broadcastLimit,
  couponsSummary,
  createProduct,
  coupons,
  couponRedeem,
  supplierCreditProviders,
  creditDetails,
  createCreditPayment,
  productMappingInventory,
  allCreditProviders,
  creditFlowRedirect,
  creditProviders,
  saveProductMapping,
  searchSupplierProductDetails,
  globalSupplierIds,
  getSuggestedProducts,
  inventoryDetails,
  supplierProductsList,
  updateInventoryStatus,
  uploadInventory,
  getPendingSFG,
  productInventory,
  updateThreshold,
  invoiceDetailsWithUpdateId,
  invoiceDetails,
  invoiceStatus,
  getAllInvoices,
  outstandingInvoices,
  supplierLedger,
  getRepresentativeLedgers,
  updateLedger,
  uploadLedger,
  removeLocation,
  addToCart,
  cartDetailsURL,
  updateCart,
  updateCartHold,
  clearCart,
  offerCreate,
  productMappingProducts,
  offerUpdate,
  getOffers,
  bannerImages,
  deleteOffer,
  cartPlaceOrder,
  orderStatuses,
  findOrders,
  getOrdersDateView,
  getOrderDetails,
  reorder,
  updateOrderByAction,
  receivedOrdersCustomers,
  updateCustomerOrdersToInvoicing,
  findOrdersByProductSearch,
  findOrdersBySupplierProductSearch,
  createLedgerOrder,
  saveParserConfig,
  fetchParserConfigTemplate,
  fetchFileHeader,
  raisePaymentRequest,
  payPayment,
  updatePayment,
  paymentRequests,
  paymentOutstanding,
  paymentCollectionStatuses,
  paymentsDownload,
  paymentTypes,
  deletePreCartItem,
  updatePreCartItem,
  addToPreCart,
  getPreCarts,
  addToCartFromPreCarts,
  getAllDrugInfo,
  getDrugSubs,
  suggestProduct,
  uploadPurchaseOrderV2,
  purchaseOrderSupplierMapping,
  purchaseOrderInventoryMapping,
  updatePurchaseOrderDetail,
  allPurchaseOrdersV2,
  deletePoDetails,
  suggestProductForPO,
  quotations,
  quotationDetails,
  createQuotation,
  quotationOrder,
  deactivateQuotation,
  getSettings,
  flipPaymentNotificationSetting,
  getAllSubscriptions,
  subscriptionPayment,
  createSupplierCustomerURL,
  allAssociatedUsers,
  supplierDetails,
  allAssociatedUsersList,
  customersUpdate,
  deleteAssociation,
  customersBlock,
  suppliersPriority,
  suggestSupplier,
  updateSalesmanCodes,
  representatives,
  representativesList,
  supplierRepresentativeList,
  updateRepresentative,
  representativeUpdate,
  representativeCreate,
  supervisorsList,
  getRepresentativeAttendance,
  supportCreateRequest,
  userStatuses,
  requestStatuses,
  updateUserProfile,
  storeUserDeviceDetails,
  userProfile,
  searchUsersURL,
  newUsersURL,
  switchRoleUrl,
  tokenByUserId,
  userSettings,
  updateSettings,
  userCreditConsent,
  userCreditConsentSave,
  userGroups,
  userGroupsList,
  userGroupURL,
  persistUserGroup,
  updateLocation,
  getRepresentativeLocation,
  userNumber,
  removeUserNumber,
  removeAllUserNumbers,
  allStates,
  allDistricts,
  fullPageBanner,
  newNotifications,
  allNotifications,
  logisticOrders,
  logisticsDropdown,
  logisticsQuotes,
  createLogisticsOrder,
  cancelLogisticsOrder,
  erpUsers,
  erpAnalytics,
  getSlabTypes,
  getSubBlocks,
  getSlabs,
  getCategories,
  updateSlabs,
  getMainBlocks,
  getSubBlockList,
  getSlabsHistory,
  getSelectTypes,
  getSaleMaterialTypes,
  getSalePolishTypes,
  getStockMaterialTypes,
  getStockPolishTypes,
  yardDetails,
  addMainBlock,
  updateMainBlock,
  getAllMainBlocks,
  getCutters,
  createSubBlock,
  getPendingSubBlocks,
  generateSlabs,
  createUser,
  addQuarry,
  addTransport,
  addMaterial,
  addCutter,
  getSubUsers,
  blockUnblockUser,
  // RMPM
  inventoryLocations,
  findPurchaseOrders,
  getPurchaseOrderDetails,
  updateOrderStatus,
  getOrderStatusSettings,
  userAllRole,
  getProductInventories,
  getLocations,
  getUserDetails,
  addLocation,
  getAllProducts,
  assignProductsToUser,
  getAllGoods,
  createRMPMUser,
  getGraniteSettings,
  updateGraniteSettings,
  getRawBlocksFactoryReport,
  getRawBlocksQuaryReport,
  getResizedBlocksFactoryReport,
  getProductionReport,
  updateQuarryStatus,
  updateTransportStatus,
  updateWireSawStatus,
  updateMulticutterStatus,
  updateMaterialStatus,
  getPolishTypes,
  addPolishType,
  updatePolishStatus,
  getSaleSelects,
  genereateRecutSubBlocks,
  addSlabs,
  deleteLastSlabs,
  deleteSaleRecord,
  allProducts,
  allProductsInventory,
  createOrder,
  scmDetails,
  scmUpdate,
  scmAdd,
  getCostHeaders,
  updateCostHeaderStatus,
  addCostHeader,
  getInventoryHeaders,
  updateInventoryHeaderStatus,
  addInventoryHeader,
  getStoreInventoryRecords,
  getProductionCostRecords,
  saveStoreInventoryRecords,
  saveProductionCostRecords,
  getMainBlockSlabCounts,
  getMainBlockSlabCountsByDimensions,
  rmpmSaleList,
  getProductsByLocation,
  saveRmpmSale,
  getScmRecord,
  addScmRecord,
  acceptComparativeStatement,
  savePreviewQuotation,
  getAllSaleQuotations,
  getAllPurchaseOrders,
  addPurchaseOrder,
  getPurchaseStatuses,
  getProductQuantities,
  createPreBatchOrder,
  updatePoStatuses,
  getAllGrn,
  addGrn,
  inventoryLocationWarehouses,
  createProductionRequirement,
  getProductById,
  getAllPreBatches,
  getPreBatchById,
  updatePreBatch,
  deletePreBatch,
  updateScmStatus,
  approveCs,
  getAllMaterialTypes,
  getGeneralConditions,
  getUserAddress,
  addDin,
  getAllDin,
  getDispatchList,
  getSettingsByUserId,
  getCompanyDetails,
  updateQuotationStatus,
  updateQuotationDetails,
  getProducts,
  getSaleForDin,
  getAllGoodsForReprocess,
  reprocessCreate,
  finishReprocess,
  getSaleQuotationById,
  getScmPo,
  getPoNumbers,
  getDetailsByPoNumber,
  getAllStatesByCountryId,
  addDispatchQuantity,
  getDispatches,
  getDinById,
  getPendingGrn,
  approveGRN,
  rejectGRN,
  addLedger,
  getPartyNames,
  getAllLedgers,
  getLedgerById,
  updateLedgerById,
  getCountries,
  getStates,
  getDistricts,
  getPartyCodes,
  getOutgoingBorrowRequests,
  getIncomingBorrowRequests,
  approveBorrowRequest,
  rejectBorrowRequest,
  lenderReservations,
  storePendingBorrowRequests,
  storeReleaseBorrowRequest,
  lenderOrderReservations,
  getHoldersByInventory,
  createBorrowRequest,
  getScmpoNumbers,
  getDinPoNumbers,
  scmProductGetDepartments,
  scmProductGetAll,
  scmProductCreateProduct,
  scmProductGetByDepartment,
  scmProductGetById,
  scmProductUpdate,
  scmProductDelete,
  getActiveCreditorLedgers,
  getActiveDebtorLedgers,
  getApprovedComparativeStatements,
  getSalesAnalytics,
  getProcessAndPackingManagers,
  updatePharmaSettings,
  getPharmaSettings,
  getCompanies,
  getCompanyLocations,
  getProductionData,
  getSaleData,
  getStoreData,
  getScmData,
  filters,
  dashboard,
  sundryBalance,
  sundryBills,
  getMonthlyBalance,
  bankBalance,
  treasureFilters,
  bankWiseBalance,
  bankWiseTransactions,
  pendingBills,
  getSalesDashboard,
  productWiseOrders,
  productSaleInfo,
  getStockDashboard,
  lowStockItems
};

export default APIConstants;
